<template>
  <div class="chart-container" ref="mychart"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'ChartsColumn',
  props: {
    title: {
      type: String,
      default: ''
    },
    // xtitle: {
    //   type: String,
    //   default: ''
    // },
    // ytitle: {
    //   type: String,
    //   default: ''
    // },
    data: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    deep: true,
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      let xData = []
      // let xtitle = ''
      // let ytitle = ''
      // let yData = []
      let namenum = 0
      let option = {}
      // let labelColor = '#999'

      if (this.data.length != 0) {
        // xtitle = this.xtitle
        // ytitle = this.ytitle
        xData = this.data.map((item) => item.label)

        // yData = this.data.map((item) => {
        //   const value = Number(item.value)
        //   if (value > 80) labelColor = '#1890ff'
        //   else if (value < 60) labelColor = '#ff4d4f'

        //   return {
        //     value,
        //     label: {
        //       color: labelColor
        //     }
        //   }
        // })
        option = {
          title: {
            //   // text: this.title,
            //   top: 15,
            //   x: '4%',
            //   textStyle: {
            //     fontSize: 16,
            //     fontWeight: 'normal'
            //   },
            //   subtextStyle: {
            //     color: '#90979c',
            //     fontSize: '14'
            //   }
          },
          tooltip: {
            trigger: 'axis',
            confine: true, // 确保不超出容器
            textStyle: {
              overflow: 'truncate' // 超出截断
            },
            extraCssText: 'word-wrap: break-word; white-space: normal;' // 关键：允许换行
            // axisPointer: {
            //   type: 'shadow',
            //   textStyle: {
            //     color: '#000'
            //   }
            // }
            // formatter: function (params) {
            //   var res = ''
            //   params.forEach(function (item) {
            //     res += item.name + xtitle + '：' + item.value + ytitle + '<br>'
            //   })
            //   return res
            // }
          },
          grid: {
            borderWidth: 0,
            top: '10%',
            left: '4%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
            textStyle: {
              color: '#000'
            }
          },
          color: 'rgba(85, 144, 217,0.8)',
          legend: {
            x: '4%',
            // top: '10%',
            textStyle: {
              color: '#90979c'
            }
          },

          calculable: true,
          xAxis: [
            {
              type: 'category',
              axisLine: {
                lineStyle: {
                  color: '#90979c'
                }
              },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitArea: {
                show: false
              },
              axisLabel: {
                //五个字换行,大于10个字后面的省略
                color: '#005eb8',

                interval: 0,
                // rotate: 10
                formatter: function (params) {
                  var newParamsName = ''
                  var paramsNameNumber = params.length
                  var provideNumber = 4 //一行显示几个字
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                  if (paramsNameNumber > provideNumber) {
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = ''
                      var start = p * provideNumber
                      var end = start + provideNumber
                      if (p == rowNumber - 1) {
                        tempStr = params.substring(start, paramsNameNumber)
                      } else {
                        tempStr = params.substring(start, end) + '\n'
                      }
                      newParamsName += tempStr
                      if (newParamsName.length > 10) {
                        newParamsName = newParamsName.substring(0, 10) + '...'
                      }
                    }
                  } else {
                    newParamsName = params
                  }
                  return newParamsName
                }
              },

              data: xData
            }
          ],
          yAxis: [
            {
              type: 'value',
              min: (value) => {
                // return value.min
                return Math.floor(value.min / 10) * 10
              },
              max: (value) => {
                return Math.ceil(value.max)
                // return Math.ceil(value.max / 100) * 100
              },
              splitLine: {
                show: false
              },
              axisLabel: { color: '#005eb8' }
            }
          ],

          dataZoom: [
            {
              type: 'slider',
              realtime: true,
              start: 0,
              end: namenum, // 数据窗口范围的结束百分比。范围是：0 ~ 100。
              height: 5, //组件高度
              left: 5, //左边的距离
              right: 5, //右边的距离
              bottom: 10, //下边的距离
              show: this.data.length > 4, // 是否展示
              fillerColor: 'rgba(17, 100, 210, 0.42)', // 滚动条颜色
              borderColor: 'rgba(17, 100, 210, 0.12)',
              handleSize: 0, //两边手柄尺寸
              showDetail: false, //拖拽时是否展示滚动条两侧的文字
              zoomLock: true, //是否只平移不缩放
              moveOnMouseMove: false, //鼠标移动能触发数据窗口平移
              //zoomOnMouseWheel: false, //鼠标移动能触发数据窗口缩放

              //下面是自己发现的一个问题，当点击滚动条横向拖拽拉长滚动条时，会出现文字重叠，导致效果很不好，以此用下面四个属性进行设置，当拖拽时，始终保持显示六个柱状图，可结合自己情况进行设置。添加这个属性前后的对比见**图二**
              startValue: 0, // 从头开始。
              endValue: 3, // 最多4个
              minValueSpan: 3, // 放大到最少几个
              maxValueSpan: 3 //  缩小到最多几个
            },
            {
              type: 'inside', // 支持内部鼠标滚动平移
              start: 0,
              end: namenum,
              zoomOnMouseWheel: false, // 关闭滚轮缩放
              moveOnMouseWheel: true, // 开启滚轮平移
              moveOnMouseMove: true // 鼠标移动能触发数据窗口平移
            }
          ],
          series: [
            {
              type: 'bar',
              barMaxWidth: '20%',
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(0,94,184,0.4)' }, // 顶部荧光绿
                  { offset: 1, color: '#005eb8' } // 底部深蓝
                ])
              },
              label: {
                show: true,
                fontSize: 14,
                position: 'top',
                formatter: '{c}'
                // 不在这里设置 color，用 data 里单独控制
              },
              data: this.data.map((item) => {
                const val = Number(item.value)
                let labelColor = '#999'
                if (val > 80) labelColor = '#1890ff'
                else if (val < 60) labelColor = '#ff4d4f'
                return {
                  value: val,
                  label: {
                    color: labelColor
                  }
                }
              })
            }
          ]
          // series: [
          //   {
          //     type: 'bar',
          //     barMaxWidth: '20%',
          //     itemStyle: {
          //       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //         { offset: 0, color: '#85F1FF' }, // 顶部荧光蓝
          //         // { offset: 0.5, color: '#00ffb0' }, // 中部荧光绿
          //         { offset: 1, color: '#005eb8' } // 底部深蓝
          //       ])
          //       // shadowColor: '#00faff',
          //       // shadowBlur: 10,
          //       // shadowOffsetY: 2
          //     },
          //     label: {
          //       show: true,
          //       fontSize: 14,
          //       position: 'top',
          //       formatter: '{c}',
          //       color: (params) => {
          //         const val = params.value
          //         if (val > 80) return '#1890ff'
          //         else if (val < 60) return '#ff4d4f'
          //         else return '#999'
          //       }
          //     },
          //     data: this.data.map((item) => Number(item.value))
          //   }
          // ]
        }
      } else {
        option = {
          title: {
            text: '暂无数据',
            x: 'center',
            y: 'center'
          }
          // graphic: {
          //   type: 'image',
          //   right: 'center',
          //   //  top: 'middle',
          //   style:{
          //     //image:''base64格式
          //   }

          //   // invisible: barChartData.xAxis.length > 0 && barChartData.series.length > 0
          // }
        }
      }

      mychart.setOption(option, true)
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>
